import { Component} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  constructor(readonly activeModal: NgbActiveModal) {}
  title: any;
  message: any;
  btnOkText: any;
  btnCancelText: any;
  buttonAlignClass: any;
  dimiss() {
    this.activeModal.close();
  }
  public decline(): void {
    this.activeModal.close(false);
  }

  public accept(): void {
    this.activeModal.close(true);
  }
}
